import * as menu from './menu'
import * as news from './news'
import * as blogs from './blogs'

export { menu, news, blogs }



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/actions/index.js